import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme.ts';
import Sidebar from './components/Sidebar.tsx';
import Home from './pages/Home.tsx';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            height: { xs: 'auto', md: '100vh' },
            overflow: { xs: 'visible', md: 'hidden' },
            bgcolor: '#0A0E2B',
          }}
        >
          <Sidebar />
          <Box
            id="main-scroll"
            sx={{
              flex: 1,
              overflowY: 'auto',
              minWidth: 0,
              height: { xs: 'auto', md: '100%' },
            }}
          >
            <Home />
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
